import React from 'react'
import HTag from '@/lib/HTag'
import Richtext from '@/lib/rt/Richtext'
import RtLink from '@/lib/rt/RtLink'
import CTA from '@/lib/CTA'
import Img from '@/lib/Img'
import clsx from 'clsx'
import * as css from './ColumnItem.module.css'

export default function ColumnItem({ heading, _rawRichtext, cta, cta2, image, icon, imageAspectRatio, stretchColumns }) {
	return (
		<article className={clsx('richtext mt-8 w-full', !stretchColumns && 'max-w-screen-md mx-auto')}>
			{!!image && (
				<figure className={clsx(css.image, 'w-full')}>
					<Img
						className={clsx(stretchColumns ? 'w-full' :'max-h-[450px]', !!imageAspectRatio && 'w-full')}
						style={{ aspectRatio: imageAspectRatio }}
						objectFit="cover"
						image={image}
						alt={heading.text}
					/>
				</figure>
			)}

			<div className="richtext">
				{!!icon && (
					<figure>
						<Img
							className="max-w-[100px] max-h-[100px]"
							objectFit="contain"
							image={icon}
						/>
					</figure>
				)}

				<HTag className="h2" {...heading} />

				<Richtext
					className={clsx(css.richtext, 'richtext')}
					raw={_rawRichtext}
					components={{
						marks: {
							link: RtLink,
						},
					}}
				/>

				<p className="flex flex-wrap items-center gap-[.5em]">
					<CTA {...cta} />
					<CTA {...cta2} />
				</p>
			</div>
		</article>
	)
}
